import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    titleShare: string;
    titleLocked: string;
    needHelp: ({ trackIntercomOpened, launcherId }: {
        trackIntercomOpened: () => void;
        launcherId: string;
    }) => React.ReactNode;
};
export type Deps = {
    StyledLink: any;
};
export default {
    DEFINE(_messages: Text, { StyledLink }: Deps): void {
        return Object.defineProperties(this, {
            /** Title when viewing a share that is unavailable */
            titleShare: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccountLockingDialogContent.titleShare?c=rnb5h7ttot9x", defaultMessage: "This Share is Unavailable" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Title when account is locked */
            titleLocked: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccountLockingDialogContent.titleLocked?c=2fh0t0347nknp", defaultMessage: "Account Locked" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Need help text with contact support link */
            needHelp: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ trackIntercomOpened, launcherId }: {
                        trackIntercomOpened: () => void;
                        launcherId: string;
                    }): React.ReactNode => __intl__.intl().formatMessage({ id: "AccountLockingDialogContent.needHelp?c=11x5c480qwlkz", defaultMessage: "<jsx>Need help?  <StyledLink>Contact Support</StyledLink></jsx>" }, { jsx: (__children__: React.ReactNode) => React.Children.toArray(__children__), StyledLink: (__children__: React.ReactNode) => <StyledLink id={launcherId} onClick={trackIntercomOpened} rel="noreferrer">{React.Children.toArray(__children__)}</StyledLink> }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps: Deps): void;
};
